import script from "./remote-auth-policy-password-link.vue?vue&type=script&lang=ts&setup=true"
export * from "./remote-auth-policy-password-link.vue?vue&type=script&lang=ts&setup=true"

import "./remote-auth-policy-password-link.vue?vue&type=style&index=0&id=49dc0658&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dc0658"]])

export default __exports__